import type { StateCreator } from 'zustand'

import type { WorkspaceStore } from '../types'

import type { WorkspaceActionsSlice } from './workspace-actions.slice.type'
import { createWorkspaceGeneralActionsSlice } from './workspace-general-actions.slice'
import { createWorkspaceMembersActionsSlice } from './workspace-members-actions.slice'
import { createWorkspaceNotificationsActionsSlice } from './workspace-notifications-actions.slice'

export const createWorkspaceActionsSlice: StateCreator<
  WorkspaceStore,
  [['zustand/immer', never]],
  [],
  WorkspaceActionsSlice
> = (...args) => ({
  ...createWorkspaceGeneralActionsSlice(...args),
  ...createWorkspaceMembersActionsSlice(...args),
  ...createWorkspaceNotificationsActionsSlice(...args),
})
